const dateDifferenceCounter = (dateString: Date) => {
  const currentDate = new Date();
  const targetDate = new Date(dateString);
  const millisecondsDifference = currentDate.getTime() - targetDate.getTime();
  const daysDifference = millisecondsDifference / (1000 * 60 * 60 * 24);
  return daysDifference;
};

export default dateDifferenceCounter;
